import UserSession from '~/backend/user_session';

const MOBIPLUS_BASE_URL = 'https://b2b.portaplus.gr:8443/MobiplusWS/AppServices';
const MOBIPLUS_TOKEN = 'eb9599ad57be524dd34874367f02290287e1ff6f';
const MOBIPLUS_SESSION = crypto.randomUUID();

export const mobiplusClickEvent = (product, clicktype) => {
	const url = new URL(`${MOBIPLUS_BASE_URL}/clickinsert_ugs`);
	const productId = composeProductIdFromProduct(product);

	url.searchParams.append('itemid', productId);
	url.searchParams.append('clicktype', clicktype);

	sendMobiplusEvent(url);
};

export const mobiplusPurchaseEvent = (order, orderItems) => {
	orderItems.forEach(orderItem => {
		const url = new URL(`${MOBIPLUS_BASE_URL}/saleinsert_ugs`);
		const productId = composeProductIdFromOrderItem(orderItem);

		url.searchParams.append('itemid', productId);
		url.searchParams.append('purchaseprice', orderItem.upr);
		url.searchParams.append('name', orderItem.pnm);
		url.searchParams.append('timestamp', order.pdt);

		sendMobiplusEvent(url);
	});
};

export const mobiplusHomepageRecommendations = () => {
	let url = new URL(`${MOBIPLUS_BASE_URL}/reco_session_ugs`);
	if (UserSession.getId()) {
		url = new URL(`${MOBIPLUS_BASE_URL}/reco_user_ugs`);
	}
	url.searchParams.append('itemsid', '');

	return getMobiplusRecommendations(url);
};

export const mobiplusRelatedProductRecommendations = productid => {
	const url = new URL(`${MOBIPLUS_BASE_URL}/reco_text_ugs`);
	url.searchParams.append('itemsid', productid);

	return getMobiplusRecommendations(url);
};

export const mobiplusCartRecommendations = productids => {
	const url = new URL(`${MOBIPLUS_BASE_URL}/reco_text_ugs`);
	url.searchParams.append('itemsid', productids.join(','));

	return getMobiplusRecommendations(url);
};

const sendMobiplusEvent = url => {
	url.searchParams.append('userid', UserSession.getId() ?? '0');
	url.searchParams.append('sessionid', MOBIPLUS_SESSION);
	url.searchParams.append('token', MOBIPLUS_TOKEN);

	fetch(url);
};

const getMobiplusRecommendations = url => {
	url.searchParams.append('userid', UserSession.getId() ?? '0');
	url.searchParams.append('sessionid', MOBIPLUS_SESSION);
	url.searchParams.append('token', MOBIPLUS_TOKEN);

	return fetch(url)
		.then(response => response.json())
		.catch(error => {
			console.error('Failed to fetch Mobiplus recommendations:', error);
			return [];
		});
};

// If there the product bought is a variant we return ProductId + ProductDimensionId
const composeProductIdFromOrderItem = orderItem => {
	// if (orderItem.pdid) {
	// 	const dimension = orderItem.dimensions.find(x => x.id === orderItem.pdid && x.cval);

	// 	if (dimension?.PrevId) {
	// 		return dimension.PrevId;
	// 	}

	// 	if (dimension.cval) {
	// 		return orderItem.pid + '-' + dimension.cval;
	// 	}
	// }

	return orderItem.pid;
};

const composeProductIdFromProduct = product => {
	// if (product.dimensions) {
	// 	const dimension = product.dimensions.find(x => x.cval);

	// 	if (dimension?.PrevId) {
	// 		return dimension.PrevId;
	// 	}

	// 	if (dimension.cval) {
	// 		return product.id + '-' + dimension.cval;
	// 	}
	// }

	return product.id;
};
